import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { H2 } from "@/components/ui/typography";
import { MasterParamCreateForm } from "@/features/master-param/MasterParamCreateForm";

export function MasterParamCreate() {
  return (
    <>
      <Breadcrumbs
        list={[
          {
            label: "Master Data",
          },
          {
            href: "/master-data/master-param",
            label: "Master Param",
          },
          {
            label: "Add",
          },
        ]}
      />
      <H2>Add Master Param</H2>
      <MasterParamCreateForm />
    </>
  );
}
